import React, { KeyboardEvent, MouseEvent } from 'react';

import classNames from 'classnames';

import { Link } from '@vk-hr-tek/ui/Link';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Box } from '@vk-hr-tek/ui/Box';

import { useUrlWithPrefix } from '../../../hooks';

interface SubmenuItemProps {
  title: string;
  href: string;
  aqaClass: string;
  isActive: boolean;
  isCustom?: boolean;
  external?: boolean;
  blank?: boolean;
  closeDrawer?: (event: KeyboardEvent | MouseEvent) => void;
  onMenuItemClick: (pageTitle: string, isActive: boolean) => void;
  handleClose?: () => void;
  classes: Record<string, string>;
  sidebarOpened: boolean;
}

export const SubmenuItem = ({
  title,
  href,
  aqaClass,
  isActive,
  isCustom = false,
  external = false,
  blank = false,
  closeDrawer,
  onMenuItemClick,
  handleClose,
  classes,
  sidebarOpened,
}: SubmenuItemProps) => {
  const className = sidebarOpened ? classes.submenuItem : classes.popupMenuItem;
  const content = (
    <Box
      className={classNames(className, isActive && classes.active, aqaClass)}
    >
      <Typography variant="body3" noWrap>
        {title}
      </Typography>
    </Box>
  );

  const urlWithPrefix = useUrlWithPrefix(external);

  const handleClick = (e: MouseEvent) => {
    closeDrawer?.(e);
    handleClose?.();
    if (!isActive) {
      onMenuItemClick(title, isActive);
    }
  };

  if (isCustom) {
    return (
      <a
        href={href}
        onClick={handleClick}
        target={blank ? '_blank' : '_self'}
        style={{ textDecoration: 'none' }}
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  }

  return (
    <Link
      {...urlWithPrefix(href)}
      variant="simple"
      onClick={handleClick}
      toPageTitle={title}
    >
      {content}
    </Link>
  );
};
